module.exports = __webpack_public_path__ + "static/media/www.jokerit.fi.025bae56.png";